import React, { useEffect } from 'react';
import { MainBackground, NavMenu, ApptronikLogo, HomeIcon, PeopleIcon, MissionsIcon, Black, IconGray } from '@apptronik/react-exoskeleton'
import { Outlet, useLocation, useNavigate } from 'react-router';
import DescriptionIcon from '@mui/icons-material/Description';
import GroupIcon from '@mui/icons-material/Group';
import query_data from '../../js/query_data';
import { isAdmin } from '../../js/auth_helpers';

export default function AppTabs() {
    const location = useLocation();
    const navigate = useNavigate();
    const [self, setSelf] = React.useState(null);

    useEffect(() => {
        if (location.pathname === '/app/' || location.pathname === '/app') {
            navigate('/app/admin')
        }
        const fetchSelf = async () => {
            const data = await query_data('/users/get_self', {});
            setSelf(data[0]);
        };
        fetchSelf();
    }, [])

    const userIsAdmin = (): boolean => {
        return isAdmin(self);
    }

    const splitPath = location.pathname.split('/').filter((path) => path !== '');
    const currentTab = `/${splitPath[0]}/${splitPath[1]}`;

    const menuItems = [
        { name: 'Profile', link: '/app/profile', icon: <PeopleIcon fill={location.pathname.startsWith("/app/profile") ? Black : IconGray} /> },
        { name: 'Data Platform', link: '/app/dataplatform', icon: <MissionsIcon fill={location.pathname.startsWith("/app/dataplatform") ? Black : IconGray} /> },
    ];
    if (userIsAdmin()) {
        menuItems.unshift({ name: 'Admin', link: '/app/admin', icon: <HomeIcon fill={location.pathname.startsWith("/app/admin") ? Black : IconGray} /> });
        menuItems.push({ name: 'People', link: '/app/people', icon: <PeopleIcon fill={location.pathname.startsWith("/app/people") ? Black : IconGray} /> });
        menuItems.push({ name: 'Role', link: '/app/role', icon: <GroupIcon sx={{ fill: location.pathname.startsWith("/app/role") ? Black : IconGray }} /> });
        menuItems.push({ name: 'Licenses', link: '/app/licenses', icon: <DescriptionIcon sx={{ fill: location.pathname.startsWith("/app/licenses") ? Black : IconGray }} /> });
    }

    return (
        <main style={{ display: 'grid', height: '100vh', gridTemplateColumns: '80px 1fr', backgroundColor: MainBackground }}>
            <NavMenu
                selectedPath={currentTab}
                headerIcon={<ApptronikLogo />}
                logout={() => {
                    localStorage.removeItem('isaacToken');
                    navigate('/login');
                }}
                menuItems={menuItems}
                headerLink='/app/admin'
            >
            </NavMenu>
            <Outlet />
        </main>
    )
}